export const getCollection = `
id
sk
name
idInc
isUserFavorite
isUserWatcher
`;
